import { Component, Output, EventEmitter, inject, computed } from '@angular/core';
import { ThemeService } from '../services/theme';

@Component({
  selector: 'app-back-navigation-bar',
  templateUrl: './back-navigation-bar.html',
  styleUrl: './back-navigation-bar.scss',
  standalone: true,
})
export class BackNavigationBar {
  @Output() backClick = new EventEmitter<void>();

  private readonly themeService = inject(ThemeService);

  chevronPath = computed(() => (this.themeService.isLight() ? '/arrow-light.svg' : '/arrow.svg'));
}
